import { useEffect, useState } from "react";
import { tr } from "@/i18n/tr";

const webVer = () => localStorage.getItem("sellox_force_ver") || "";

// Shared version state: desktop (Electron) version + web bundle version + update progress.
export function useAppVersion() {
  const [desktopVer, setDesktopVer] = useState("");
  const [upd, setUpd] = useState(null);
  const [newWebVer, setNewWebVer] = useState("");
  useEffect(() => {
    const d = window.selloxDesktop;
    if (d) {
      if (d.getVersion) d.getVersion().then(v => setDesktopVer(v || d.version || "?")).catch(() => setDesktopVer(d.version || "?"));
      else setDesktopVer(d.version || "?");
    }
    let last = "";
    const pollDesktop = async () => {
      if (!d?.getUpdateStatus) return;
      try {
        const st = await d.getUpdateStatus();
        const j = JSON.stringify(st || null);
        if (j !== last) { last = j; setUpd(st); }
      } catch {}
    };
    const pollWeb = async () => {
      try {
        const r = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
        if (!r.ok) return;
        const { version } = await r.json();
        const cur = webVer();
        setNewWebVer(version && cur && version !== cur ? version : "");
      } catch {}
    };
    pollDesktop(); pollWeb();
    const t1 = setInterval(pollDesktop, 30000);
    const t2 = setInterval(pollWeb, 5 * 60 * 1000);
    return () => { clearInterval(t1); clearInterval(t2); };
  }, []);
  const isDesktop = !!window.selloxDesktop;
  const label = isDesktop ? `Desktop v${desktopVer || "…"} · Web ${webVer()}` : `Web ${webVer()}`;
  return { isDesktop, desktopVer, webVer: webVer(), label, upd, newWebVer };
}

export function VersionBadge({ variant = "pos" }) {
  const { label, upd, newWebVer } = useAppVersion();
  const downloading = upd?.state === "downloading";
  const ready = upd?.state === "ready";
  const hasUpdate = downloading || ready || !!newWebVer;
  const updText = downloading ? `${tr("x_e2efd3fa")}${upd.version} ${tr("x_2d455ce5")} ${upd.percent}%`
    : ready ? `${tr("x_51a8f63f")}${upd.version} ${tr("x_c540ce8f")}`
    : newWebVer ? `${tr("verNewWeb")} ${newWebVer} · ${tr("verClickReload")}` : "";
  const onClick = () => { if (newWebVer && !downloading && !ready) window.location.reload(true); };
  if (variant === "admin") {
    return (
      <div className="px-3 pt-1 space-y-0.5" data-testid="app-version">
        {hasUpdate && (
          <button type="button" onClick={onClick} className="block w-full text-left text-[11px] font-semibold text-amber-300 bg-amber-500/10 border border-amber-500/30 rounded px-2 py-1 hover:bg-amber-500/20 transition-colors" data-testid="admin-update-banner">
            {updText}
          </button>
        )}
        <div className="text-[11px] font-mono text-slate-400" data-testid="app-version-label">Sellox · {label}</div>
      </div>
    );
  }
  if (variant === "inline") {
    return (
      <div onClick={onClick} style={hasUpdate ? { background: "#f59e0b", color: "#111" } : { background: "#1e4fa3", color: "#fff" }} className={`mt-1 rounded px-1.5 py-0.5 text-[10px] font-mono font-semibold ${hasUpdate ? "cursor-pointer" : ""}`} data-testid="pos-version-badge">
        {hasUpdate && <div data-testid="pos-update-text">{updText}</div>}
        <div>{label}</div>
      </div>
    );
  }
  return (
    <div
      onClick={onClick}
      style={hasUpdate ? { background: "#f59e0b", color: "#111" } : { background: "rgba(15,23,42,0.75)", color: "#f1f5f9" }}
      className={`fixed bottom-1 right-1.5 z-[60] text-[11px] font-mono font-semibold px-2 py-0.5 rounded shadow-sm ${hasUpdate ? "cursor-pointer" : "pointer-events-none"}`}
      data-testid="pos-version-badge"
    >
      {hasUpdate && `${updText} · `}{label}
    </div>
  );
}
